const PAGE_SEARCH = 'Search';
const PAGE_SELECT = 'Select';
const PAGE_RESUME = 'Resume';
const PAGE_PASSENGERS = 'Passengers';
const PAGE_CHECKOUT = 'Checkout';
const PAGE_CONFIRMATION = 'Confirmation';
const TUDO_AZUL_CLASSIFICATION = 'TudoAzul';

function validateTealiumObject() {
  if (!global.utag_data) {
    console.warn('Tealium Azul object not defined, verify the analytics configuration.');
    return false;
  }
  return true;
}

function checkSendViewTealium() {
  if (typeof window.utag !== 'undefined') {
    return true;
  }
  console.error('Analytics send tag tealium not defined.');
  return false;
}

function getDevice() {
  const size = window.innerWidth;
  if (!size) {
    return '';
  } else if (size >= 1200) {
    return 'desktop';
  } else if (size >= 768) {
    return 'tablet';
  } else {
    return 'mobile';
  }
}

function setSearchTealiumAzulObject() {
  global.utag_data.section = 'fluxo-compra';
  global.utag_data.siteLanguage = 'pt';
  global.utag_data.transaction = false;
  global.utag_data.device = getDevice();
}

function setPassengersTealiumAzulObject(loginData) {
  global.utag_data.user_tudoAzulNumber = loginData.username;
  global.utag_data.user_pointsBalance = loginData.pointsBalance;
  global.utag_data.user_userClassification = loginData.userClassification
    ? loginData.userClassification
    : TUDO_AZUL_CLASSIFICATION; 
  global.utag_data.vistorLoginStatus = true;
  
}

function setTealiumTransaction(transaction) {
  global.utag_data.transaction = transaction;
}

function trackingPageTealium(page) {
  global.utag_data.pageName = page;
  if(checkSendViewTealium()){  
   window.utag.view(global.utag_data);
  }  
}

const Analytics = {
  trackingSearch: function() {
    global.initTealiumObject();
    if (validateTealiumObject()) {
      setSearchTealiumAzulObject();
      trackingPageTealium(PAGE_SEARCH);
    }
  },
  trackingSelect: function(dataSelect) {   
    if (validateTealiumObject()) {
      setSearchTealiumAzulObject();
      trackingPageTealium(PAGE_SELECT);
    }
  },
  trackingResume: function(dataSelect, originFlightSelected, returnFlightSelected) {
    if (validateTealiumObject()) {
      setSearchTealiumAzulObject();
      trackingPageTealium(PAGE_RESUME);
    }
  },
  trackingPassengers: function(dataSelect, dataOrigin, dataReturn, loginData) {   
    if (validateTealiumObject()) {
      setSearchTealiumAzulObject();
      setPassengersTealiumAzulObject(loginData);
      trackingPageTealium(PAGE_PASSENGERS);
    }
  },
  trackingCheckout: function(dataSelect, dataOrigin, dataReturn, dataPassengers, loginData) {  
    if (validateTealiumObject()) {
      setSearchTealiumAzulObject();
      setPassengersTealiumAzulObject(loginData);
      trackingPageTealium(PAGE_CHECKOUT);
    }
  },
  trackingConfirmation: function(
    dataSelect,
    dataOrigin,
    dataReturn,
    dataPassengers,
    dataCheckout,
    loginData
  ) {    
    if (validateTealiumObject() && dataSelect && dataOrigin && dataPassengers && dataCheckout) {
      setSearchTealiumAzulObject();
      setPassengersTealiumAzulObject(loginData);      
      setTealiumTransaction(true);
      trackingPageTealium(PAGE_CONFIRMATION);
    }
  },
  
};

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/modules/tudo-azul-analytics/index.js